import { Component, Input } from '@angular/core';

/** Pastilla de titulo de cristal teñido (teal por defecto) con icono opcional. */
@Component({
  selector: 'app-pill-title',
  templateUrl: './pill-title.component.html',
  styleUrl: './pill-title.component.scss',
  standalone: false,
})
export class PillTitleComponent {
  @Input() public title = '';
  /** teal | red | magenta | purple | teal-solid */
  @Input() public variant: 'teal' | 'red' | 'magenta' | 'purple' | 'teal-solid' = 'teal';
  /** Muestra el circulo con el icono de barras a la izquierda. */
  @Input() public withIcon = false;
  @Input() public align: 'start' | 'center' = 'center';

  public get pillClass(): string {
    const map: Record<string, string> = {
      teal: '',
      red: 'z-pill--red',
      magenta: 'z-pill--magenta',
      purple: 'z-pill--purple',
      'teal-solid': 'z-pill--teal',
    };
    return map[this.variant] ?? '';
  }
}
